/* istanbul ignore file */
import React from 'react';
import { DOCUMENTS } from 'domain/shared/employee';
import { EnumDropdown, DefaultDropdownProps } from 'framework/form';

const DocumentsDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return <EnumDropdown placeholder="Select type" options={DOCUMENTS} {...props} />;
};

export default DocumentsDropdown;
